import "../../../../src/content/wg-stream-donor-page/wg-stream-donor-page.scss";
import * as React from 'react';
export default {
  React
};